var map = {
	"./en.json": 819,
	"./it.json": 820
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2052;



/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n \.json.*$
 ** module id = 2052
 ** module chunks = 0
 **/